<template>
  <v-sheet v-if="localData" class="d-flex justify-center overflow-auto" :height="height">
    <v-sheet class="align-self-center" max-width="400">
      <v-sheet outlined class="pa-4 mb-4" rounded>
        <v-row class="rowSmall" align="center">
          <v-col cols="auto"><v-icon>mdi-information</v-icon></v-col>
          <v-col class="body-2">Выберите на основе каких исходных данных<br/>будет создана рассылка</v-col>
        </v-row>
      </v-sheet>
      <v-select
          label="Исходные данные"
          v-model="localData.data"
          :items="[
          //{name:'Пользователи',value:null},
          {name:'Визиты',value:'visit'},
        ]"
          :rules="formFieldRules.required"
          outlined dense hide-details="auto" class="mb-3"
          item-text="name"/>
    </v-sheet>
  </v-sheet>

</template>

<script>
import {FormFieldRules} from "@/plugins/formFieldRules";

export default {
  props: ['data','height'],
  data: () => ({
    localData:null,
    formFieldRules: FormFieldRules,
  }),
  mounted() {
    this.localData = this.data;
  },
  watch: {
    data() {
      this.localData = this.data;
    },
    localData(){
      this.$emit('update', this.localData)
    },
  }
}
</script>